import React, { useState, useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import DropDown from '../dropDown/MultDropdownCheckbox';
import styles from './filter.module.css';
import IMAGES from '../../assets/images/images';

export const Filter = ({ position, isOpen, onRequestClose, options, onApply, label, initialSelectedOptions, onReset, maxSelectionCount=3,type=null }) => {
    const [selectedFilterOptions, setSelectedFilterOptions] = useState(initialSelectedOptions || []);
    const filterRef = useRef(null);
    const [note, setNote] = useState(false)
    const uniqueOptions = useMemo(() => {
        const allOptions = [...(initialSelectedOptions || []), ...(options || [])];
        const seen = new Set();
        return allOptions.filter(option => {
            if (seen.has(option.value)) return false;
            seen.add(option.value);
            return true;
        });
    }, [initialSelectedOptions, options]);
    // const uniqueOptions = Array?.from(new Set(options?.map(option => option.value)))
    //     ?.map(value => options?.find(option => option?.value === value));

    const handleChange = (selected) => {
        if (maxSelectionCount && selected.length > maxSelectionCount) {
            setNote(true)
            return
        }
        setSelectedFilterOptions(selected);
    };

    const handleApply = () => {
        onApply(selectedFilterOptions);
        onRequestClose();
    };

    const reset = () => {
        setSelectedFilterOptions([]);
        onReset();
    };

    const handleClickOutside = (event) => {
        if (filterRef.current && !filterRef.current.contains(event.target)) {
            onRequestClose();
            setNote(false)
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={position? styles[position] : styles.modal} ref={filterRef}>
            <div className={styles.header}>
                <div id="filter-dialog-title"><span>Apply Filter</span>{note&&<span className={styles.note}>Maximum {maxSelectionCount} filters allowed.</span>}</div>
                <img className={styles.close} src={IMAGES.close} onClick={onRequestClose} alt="close" />
            </div>
            <div className={styles.multiselect}>
                <div className={styles.label}>{label}</div>
                <DropDown
                    options={uniqueOptions}
                    placeholder="Select"
                    onChange={handleChange}
                    value={selectedFilterOptions}
                    hasError={false}
                    filterType={type}
                    menuIsOpen={isOpen}
                />
            </div>
            <div className={styles.footer}>
                <button onClick={reset} className={styles.closeButton}>Reset</button>
                <button onClick={handleApply} disabled={selectedFilterOptions.length === 0} className={`${styles.applyButton} ${selectedFilterOptions.length === 0 ? styles.disabled : ''}`}>Apply</button>
            </div>
        </div>
    );
};

Filter.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    })).isRequired,
    onApply: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    initialSelectedOptions: PropTypes.array
};

// export default Filter;

export const AppliedFilter = ({ selectedFilterOptions, onReset, setSelectedFilterOptions, selectedInvoicingPartyOptions,handleFilterApply, handleInvoicingFilterApply,firstFilterLabel=null,secondFilterLabel=null}) => {
    const handleRemove = (itemToRemove) => {
        const updatedOptions = selectedFilterOptions.filter(item => item.value !== itemToRemove.value);
        setSelectedFilterOptions(prevState => ({
          ...prevState,
          selectedFilterOptions: updatedOptions
        }));
        handleFilterApply(updatedOptions);

        // if (updatedOptions.length > 0) {
        //   handleFilterApply(updatedOptions);
        // } else {
        //     if(selectedInvoicingPartyOptions?.length===0){
        //         reset();
        //     }else if(updatedOptions.length === 0&&selectedInvoicingPartyOptions?.length>0){
        //         handleInvoicingFilterApply(selectedInvoicingPartyOptions,"lastremoved");
        //     }
        // }
      };

      const handleInvoicingRemove = (itemToRemove) => {
        const updatedOptions = selectedInvoicingPartyOptions.filter(item => item.value !== itemToRemove.value);

        setSelectedFilterOptions(prevState => ({
          ...prevState,
          selectedInvoicingPartyOptions: updatedOptions
        }));
        handleInvoicingFilterApply(updatedOptions)

        // if (updatedOptions.length > 0) {
        //     handleInvoicingFilterApply(updatedOptions);
        // } else {
        //     if(selectedFilterOptions?.length===0){
        //         reset();
        //     }else if(updatedOptions.length === 0&&selectedFilterOptions?.length>0){
        //         handleFilterApply(selectedFilterOptions,"lastremoved");
        //     }
        // }
      };
    
      const reset = () => {
        setSelectedFilterOptions(prevState => ({
          ...prevState,
          selectedFilterOptions: [],
          selectedInvoicingPartyOptions:[]
        }));
        onReset();
      };

    return (
        <div className={styles.parent}>
            <div className={styles.subparent}>
                <div className={styles.text}>Filters Applied:</div>
                <div className={styles.wrapper}>
                {selectedFilterOptions?.length>0&&(
                <div className={styles.invoiced}>
                    <div className={styles.invoicedtext}>{firstFilterLabel}:</div>
                    <div className={styles.invoicedData}>
                        {selectedFilterOptions?.map((item, index) => (
                            <div key={index} className={styles.invoicelabel}>
                                {item.label}
                                <img className={styles.cancel} src={IMAGES.close} alt="close"onClick={() => handleRemove(item)}/>
                            </div>
                        ))}
                    </div>
                </div>
                 )}
                {selectedInvoicingPartyOptions?.length>0&&(
                <div className={styles.invoiced}>
                    <div className={styles.invoicedtext}>{secondFilterLabel}:</div>
                    <div className={styles.invoicedData}>
                        {selectedInvoicingPartyOptions?.map((item, index) => (
                            <div key={index} className={styles.invoicelabel}>
                                {item.label}
                                <img className={styles.cancel} src={IMAGES.close} alt="close"onClick={() => handleInvoicingRemove(item)}/>
                            </div>
                        ))}
                    </div>
                </div>
                )}
                </div>
            </div>
            <div className={styles.resetfil} onClick={reset}>
                {/* <img className={styles.reseticon} src={IMAGES.reseticon} alt="reset" /> */}
                Clear Filter
            </div>
        </div>
    );
};

AppliedFilter.propTypes = {
    selectedFilterOptions: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    onReset: PropTypes.func.isRequired,
    setSelectedFilterOptions: PropTypes.func.isRequired,
};